import { render, staticRenderFns } from "./najlepsze-spolki-farmaceutyczne-na-gieldzie.md?vue&type=template&id=36f3a428&"
var script = {}


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports